export default __webpack_public_path__ + "static/media/g4.ff891e8f.jpg";